import React,{useState, useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter } from "react-router-dom";
//import { resolve } from 'path';
// MSAL imports
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from "@azure/msal-browser";
import { loginRequest, msalConfig } from './utils/authConfig';
import { setupAxiosRequestInterceptor, setupAxiosResponseInterceptor } from './utils/axiosInterceptors';
//import { setupAxiosRequestInterceptor, setupAxiosResponseInterceptor } from './components/axiosInterceptors';

// Remove this line
// import 'dotenv/config';


export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  // Set up Axios interceptors
  setupAxiosRequestInterceptor(msalInstance);
  setupAxiosResponseInterceptor(msalInstance);
  
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  const accounts = msalInstance.getAllAccounts();

  //if (existingAccount) {
  //  const activeAccount = accounts.find(acc => acc.username === existingAccount);
  //  if (activeAccount) {
  //    msalInstance.setActiveAccount(activeAccount);
  //    return;
  //  }
  //}
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }
  
  // Event callback for login success
  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
      localStorage.setItem('account', account.username);
      const GetToken = async () => {
        const token = await msalInstance.acquireTokenSilent({ ...loginRequest, account })
        localStorage.setItem('token', token.accessToken);
        account.username === 'Surfacebham@themagnigroup.onmicrosoft.com' ? localStorage.setItem('isTablet', 'true') : localStorage.setItem('isTablet', 'false');
      }
      GetToken();
    }
  });

  // Render the application after MSAL initialization
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <BrowserRouter>
      <App pca={msalInstance}/>
    </BrowserRouter>
  );
});